import { createSelector } from '@ngrx/store';

import { onlineMenuProductsImagesState } from '../root';

export const getImagesForOnlineMenuPage = (pageId: number) =>
    createSelector(onlineMenuProductsImagesState, (onlineMenuPagesImages) => onlineMenuPagesImages.find((obj) => obj.pageId === pageId) || null);
